exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tag-info[data-v-5ccf81ca]{max-width:calc(50% - 5px)}.align-right[data-v-5ccf81ca]{text-align:right}.pr0[data-v-5ccf81ca]{padding-right:0;padding-bottom:36px}\n", ""]);

